import {POST} from "@/services/gateway";

const listRestores = ({pagination, sourceType, dataTypes, dataProvider = 'GOOGLE'}) => {
  return POST('recovery/restore/list', {pagination, sourceType, dataTypes, dataProvider})
}

export {
  listRestores
}
